import React from 'react';
import { X } from 'lucide-react';

export const ConversationModal = ({ conversation, onClose, onInterveneAgent, onInterveneDirect }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl w-full max-w-3xl max-h-[80vh] flex flex-col">
        <div className="p-4 border-b flex justify-between items-center">
          <div>
            <h3 className="text-xl font-bold">
              {conversation.user_data?.name || 'Client'}
              {conversation.user_data?.phone && (
                <span className="text-gray-500 text-sm ml-2">{conversation.user_data.phone}</span>
              )}
            </h3>
            {conversation.user_data?.device_model && (
              <p className="text-sm text-gray-600">📱 {conversation.user_data.device_model}</p>
            )}
          </div>
          <button onClick={onClose}><X size={24} /></button>
        </div>
        <div className="flex-1 overflow-y-auto p-4 space-y-4">
          {conversation.messages?.map((msg, idx) => (
            <div key={idx} className={`flex ${msg.role === 'user' ? 'justify-end' : 'justify-start'}`}>
              <div className={`max-w-[70%] rounded-2xl px-4 py-2 ${
                msg.role === 'user' ? 'bg-blue-600 text-white'
                  : msg.role === 'admin' ? 'bg-green-600 text-white'
                  : 'bg-gray-100 text-gray-800'
              }`}>
                {msg.role === 'admin' && <span className="text-xs font-bold">ADMIN</span>}
                <p className="whitespace-pre-wrap">{msg.content}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="p-4 border-t flex space-x-2">
          <button onClick={onInterveneDirect}
            className="flex-1 bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg">
            💬 Intervenir directement
          </button>
          <button onClick={onInterveneAgent}
            className="flex-1 bg-orange-500 hover:bg-orange-600 text-white px-4 py-2 rounded-lg">
            📱 Notifier agent
          </button>
        </div>
      </div>
    </div>
  );
};
